export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'ID du magasin : ',
    },
    url: {
      label: 'URL : ',
    },
    username: {
      label: "Nom d'utilisateur : ",
      placeholder: "Nom d'utilisateur pour l'authentification entre votre boutique et WinOrder",
      validation: {
        required: "Le nom d'utilisateur ne peut pas être vide",
        min: "La longueur minimale du nom d'utilisateur est de 3 caractères",
      },
    },
    password: {
      label: 'Mot de passe : ',
      placeholder: "Mot de passe pour l'authentification entre votre boutique et WinOrder",
      validation: {
        required: 'Le mot de passe ne peut pas être vide',
        complexity: 'Le mot de passe doit comporter au moins 8 caractères et contenir au moins une lettre',
      },
    },
  },
  labels: {
    credentials: 'Identifiants :',
  },
  instructions: {
    title: 'Instructions de configuration :',
    step_1: 'Ouvrez « Paramètres » → « Paramètres du programme » dans WinOrder.',
    step_2: 'En haut, vous trouverez le bouton « Configuration de la boutique en ligne ».',
    step_3:
      'Dans la fenêtre suivante, vous trouverez tous les magasins préconfigurés dans WinOrder. Sélectionnez « FoodAmigos » puis cliquez sur « Suivant ».',
    step_4:
      'Dans la fenêtre suivante, remplacez <0>{{storeid_placeholder}}</0> par <1>{{company_id}}</1> dans le champ « URL du service web ». <br />Le résultat final devrait ressembler à ceci : <2>{{url}}</2>',
    step_5:
      "Dans la même fenêtre, saisissez <ClickToCopy>{{username}}</ClickToCopy> dans le champ « Nom d'utilisateur ».",
    step_6:
      'Dans la même fenêtre, saisissez <ClickToCopy>{{password}}</ClickToCopy> dans le champ « Mot de passe ». Cliquez ensuite sur le bouton « Suivant ».',
    step_7:
      "WinOrder teste maintenant la connexion à l'interface FoodAmigos. Cliquez sur « Suivant » puis sur « Terminer » dans la fenêtre suivante.",
    step_8: 'Enregistrez les paramètres.',
  },
  buttons: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    edit: 'Modifier',
  },
  toasts: {
    error: "Échec de l'enregistrement des modifications",
    success: 'Modifications enregistrées',
  },
};
